module.exports = __webpack_public_path__ + "img/truckTrailerFrontLeft.4f97f472.svg";